import React from 'react';
import PropTypes from 'prop-types';
import Heading from "../Heading/Heading";
import Eyebrow from "../Eyebrow/Eyebrow";

interface HeadingRowProps {
    title: string;
    size?: 1 | 2 | 3 | 4 | 5 | 6;
    eyebrow?: string;
    // Baseline arguments
    children?: React.ReactNode;
    className?: string;
}

/**
 * A heading row that fills the top portion of modals and drawers. Consists of an eyebrow and a heading wrapped in a class.
 * 
 * ## _
 * ### Arguments
 * @param {string} title - Text that is used to populate the inner Heading.
 * @param {int} size - Any number from 1 to 6. Aligns with the traditional heading numbers, where 1 = highest emphasis, 6 = lowest. Populates the size prop for the inner Heading.
 * @param {string} eyebrow - Text that is used to populate the inner Eyebrow.
 * @param {React.ReactNode} children - The contents inside the heading row. This is the remainder of the heading row.
 * @param {string} className - CSS classes to apply to the heading row.
 */
class HeadingRow extends React.Component<HeadingRowProps> {
    static propTypes = {
        title: PropTypes.string.isRequired,
        size: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
        eyebrow: PropTypes.string,
        children: PropTypes.node,
        className: PropTypes.string,
    }

    static defaultProps = {
        className: "",
        size: 1,
    }

    render() {
        const { title, size, eyebrow, children, className, ...rest} = this.props;

        return (
            <div className={`m-heading-row ${className}`} {...rest}>
                <div className="m-heading-row__title">
                    {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
                    <Heading size={size} className="l-mb-none">{title}</Heading>
                </div>
                {children && <div className="m-heading-row__actions">{children}</div>}
            </div>
        );
    }
}

export default HeadingRow;